import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmSmileIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmSmileIcon = ({ className, ...props }: EmSmileIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.9313 20.4188C6.13596 20.4188 0.962524 17.4109 0.962524 10.8109C0.962524 4.21094 6.13596 1.20312 10.9313 1.20312C13.5953 1.20312 16.0531 2.07969 17.875 3.67812C19.8516 5.43125 20.9 7.90625 20.9 10.8109C20.9 13.7156 19.8516 16.1734 17.875 17.9266C16.0531 19.525 13.5781 20.4188 10.9313 20.4188Z"
      fill="url(#paint0_radial_518_36062)"
    />
    <path
      d="M7.5625 7.03656C6.84234 7.03656 6.1875 7.645 6.1875 8.65562C6.1875 9.66625 6.84234 10.273 7.5625 10.273C8.28437 10.273 8.9375 9.66453 8.9375 8.65562C8.9375 7.64672 8.29125 7.03656 7.5625 7.03656Z"
      fill="#422B0D"
    />
    <path
      d="M7.50232 7.71202C7.25825 7.59514 6.96435 7.69827 6.84575 7.94233C6.75466 8.13311 6.79591 8.3617 6.94888 8.50952C7.19294 8.62639 7.48685 8.52327 7.60544 8.2792C7.69653 8.08842 7.65529 7.85983 7.50232 7.71202Z"
      fill="#896024"
    />
    <path
      d="M14.1625 7.03656C13.4423 7.03656 12.7875 7.645 12.7875 8.65562C12.7875 9.66625 13.4423 10.273 14.1625 10.273C14.8826 10.273 15.5375 9.66453 15.5375 8.65562C15.5375 7.64672 14.8826 7.03656 14.1625 7.03656Z"
      fill="#422B0D"
    />
    <path
      d="M14.0937 7.71202C13.8497 7.59514 13.5558 7.69827 13.4372 7.94233C13.3461 8.13311 13.3873 8.3617 13.5403 8.50952C13.7844 8.62639 14.0783 8.52327 14.1969 8.2792C14.288 8.08842 14.2467 7.85983 14.0937 7.71202Z"
      fill="#896024"
    />
    <path
      d="M10.8283 15.7455C9.26936 15.7575 7.78092 15.1027 6.73764 13.9442C6.65858 13.8531 6.63967 13.7242 6.68951 13.6142C6.73936 13.5025 6.84936 13.4303 6.97139 13.4286C7.02639 13.4286 7.08139 13.4441 7.12951 13.4716C7.95795 13.9477 9.34326 14.5389 10.8283 14.5389H10.8523C12.3356 14.5389 13.7226 13.9477 14.5494 13.4716C14.5975 13.4441 14.6525 13.4286 14.7075 13.4286C14.8295 13.4303 14.9395 13.5025 14.9894 13.6142C15.0409 13.7242 15.022 13.8531 14.9412 13.9442C13.898 15.1027 12.4061 15.7592 10.8472 15.7455"
      fill="#422B0D"
    />
    <path
      d="M19.1622 5.09952C20.0783 6.57764 20.5561 8.33764 20.5561 10.2953C20.5561 13.2 19.5076 15.6578 17.5311 17.4109C15.7092 19.0094 13.2342 19.9031 10.5873 19.9031C7.48327 19.9031 4.22796 18.6398 2.3064 15.9603C4.15577 18.9956 7.63452 20.4187 10.9311 20.4187C13.578 20.4187 16.053 19.525 17.8748 17.9265C19.8514 16.1734 20.8998 13.7156 20.8998 10.8109C20.8998 8.62124 20.3034 6.67561 19.1622 5.09952Z"
      fill="#EB8F00"
    />
    <defs>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(10.9313 10.8109) scale(9.78995)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_518_36062"
        r="1"
      >
        <stop
          offset="0.5"
          stopColor="#FDE030"
        />
        <stop
          offset="0.92"
          stopColor="#F7C02B"
        />
        <stop
          offset="1"
          stopColor="#F4A223"
        />
      </radialGradient>
    </defs>
  </svg>
);

export default EmSmileIcon;
